<div class="sourcing-tree">
  <div class="sourcing-tree-header">
    <h3>{{ title }}</h3>
    <p>{{ effectiveDescription }}</p>
  </div>

  <div #canvas class="sourcing-tree-canvas" [class.is-direct]="!hasFeeders">
    <svg
      class="sourcing-tree-edges"
      [attr.width]="svgWidth"
      [attr.height]="svgHeight"
      [attr.viewBox]="'0 0 ' + svgWidth + ' ' + svgHeight"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient
          id="sourcing-edge-grad"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          [attr.x2]="svgWidth"
          y2="0"
        >
          <stop offset="0" stop-color="#cbd5e180" />
          <stop offset="1" stop-color="#08b5a380" />
        </linearGradient>
        <marker
          id="sourcing-edge-arrow"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="7"
          markerHeight="7"
          orient="auto"
        >
          <path d="M0,0 L10,5 L0,10 z" fill="#08b5a380" />
        </marker>
      </defs>

      @for (edge of edges; track edge.id) {
        <path class="edge-base" [attr.d]="edge.path" marker-end="url(#sourcing-edge-arrow)"></path>
        <path class="edge-flow" [attr.d]="edge.path"></path>
        <!-- foreignObject so the label can be a real bordered pill (background/border/border-radius) rather than
             plain SVG text -- SVG text has no equivalent of an auto-sizing background shape without manually
             measuring and drawing a rect behind it. The box is generously oversized and centered on labelX/Y via
             flex, with overflow: visible as a safety net, so it self-sizes to whatever the label text needs
             instead of clipping or leaving excess padding for shorter labels. -->
        <foreignObject
          [attr.x]="edge.labelX - 80"
          [attr.y]="edge.labelY - 14"
          width="160"
          height="28"
          style="overflow: visible"
        >
          <div xmlns="http://www.w3.org/1999/xhtml" class="edge-label-wrap">
            <span class="edge-label-pill">{{ edge.label }}</span>
          </div>
        </foreignObject>
      }
    </svg>

    @if (hasFeeders) {
      <div class="sourcing-tree-sources">
        @for (node of sourceNodes; track node.id; let i = $index) {
          <div #sourceCard class="sourcing-tree-node" [style.animation-delay.ms]="i * 60">
            <app-wallet-card
              [id]="node.id"
              [name]="node.name"
              [address]="node.address"
              [networkType]="node.networkType"
              [currencies]="node.currencies"
              [risk]="node.risk"
              [showRiskLevel]="showRiskLevel"
              [isClickable]="false"
              [compactAddress]="true"
            ></app-wallet-card>
          </div>
        }
      </div>
    }

    <div class="sourcing-tree-destination">
      <div #destCard class="sourcing-tree-node is-destination">
        <span class="sourcing-tree-destination-tag">Source wallet</span>
        <app-wallet-card
          [id]="'source'"
          [name]="sourceWallet?.walletName || ''"
          [address]="sourceWallet?.address || ''"
          [networkType]="sourceWallet?.networkType"
          [currencies]="sourceWallet?.currencies || []"
          [risk]="sourceWallet?.riskLevel || ''"
          [showRiskLevel]="showRiskLevel"
          [isClickable]="false"
          [amountRows]="[
            { label: 'Before funding', amount: sourceWallet?.availableBeforeAmount ?? 0 },
            { label: 'After funding', amount: sourceWallet?.availableAfterFundingAmount ?? 0 },
            { label: 'After withdrawal', amount: sourceWallet?.availableAfterAmount ?? 0, highlight: true },
          ]"
        ></app-wallet-card>
      </div>
    </div>

    @if (destinationWallet) {
      <div class="sourcing-tree-final-destination">
        <div #destinationCard class="sourcing-tree-node is-destination">
          <app-wallet-card
            [id]="'destination'"
            [name]="destinationWallet.walletName"
            [address]="destinationWallet.address"
            [networkType]="destinationWallet.networkType"
            [risk]="destinationWallet.riskLevel"
            [showRiskLevel]="showRiskLevel"
            [isClickable]="false"
            [compactAddress]="true"
          ></app-wallet-card>
        </div>
      </div>
    }
  </div>
</div>
